import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertCircle, Battery, Brain, UtensilsCrossed } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <AlertCircle className="w-8 h-8 text-[#C97B63]" data-id="element-165" />,
    title: 'Resistencia a la Insulina',
    desc: 'Cada ensalada que comes se convierte en reserva de grasa porque tu cortisol le ordena a tu vientre protegerse.'
  }, {
    icon: <Battery className="w-8 h-8 text-[#C97B63]" data-id="element-166" />,
    title: 'Fatiga Crónica',
    desc: 'Despiertas cansada y necesitas café para arrancar. Tu energía se desploma a media tarde.'
  }, {
    icon: <Brain className="w-8 h-8 text-[#C97B63]" data-id="element-167" />,
    title: 'Niebla Mental',
    desc: 'Sufres de falta de concentración por la tarde, olvidando cosas simples o sintiéndote abrumada.'
  }, {
    icon: <UtensilsCrossed className="w-8 h-8 text-[#C97B63]" data-id="element-168" />,
    title: 'Hambre de Ansiedad',
    desc: 'Al llegar la noche, el hambre emocional te domina, arruinando el esfuerzo de todo el día.'
  }];
  return <section className="py-20 bg-[#E8F0E8]" data-id="element-169">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-170">
        <FadeIn data-id="element-171">
          <h2 className="text-3xl md:text-4xl font-serif text-[#1A5C4C] text-center mb-12" data-id="element-172">
            Por qué tu cuerpo se volvió "sordo"
          </h2>
          <p className="text-lg text-center text-[#2A2A2A] max-w-3xl mx-auto mb-16" data-id="element-173">
            A partir de los 45 años, el descenso de estrógenos hace que tu
            cuerpo sea "sordo" a la insulina. Has intentado dietas extremas,
            pero solo logras que tu metabolismo se vuelva más lento para
            "sobrevivir".
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-174">
          {problems.map((prob, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-175">
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-[#1A5C4C]/10 flex items-start space-x-4" data-id="element-176">
                <div className="flex-shrink-0 p-3 bg-[#FDF6F0] rounded-full" data-id="element-177">
                  {prob.icon}
                </div>
                <div data-id="element-178">
                  <h3 className="text-xl font-serif text-[#1A5C4C] mb-2" data-id="element-179">
                    {prob.title}
                  </h3>
                  <p className="text-[#2A2A2A] opacity-80" data-id="element-180">{prob.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}